export const sciWidth = 50;
export const surveyWidth = 60;
export const largeWidth = 80;
export const mediumWidth = 60;
export const smallWidth = 40;
export const ageWidth = 65;
export const spellWidth = 25;
export const svgStyles = {
  height: spellWidth,
  width: spellWidth,
  padding: '2px 1px',
  fill: '#B0BECF',
};
